export type TseProviderKind = "stub" | "fiskaly" | "swissbit_cloud";
export type TseEnvironment = "test" | "live";

export interface TseSettings {
  enabled: boolean;
  provider: TseProviderKind;
  environment: TseEnvironment;
  tss_id: string | null;
  client_id: string | null;
  base_url: string | null;
  api_key_configured: boolean;
  api_secret_configured: boolean;
  configured: boolean;
}

export const TSE_PROVIDER_OPTIONS: { value: TseProviderKind; label: string; hint: string }[] = [
  {
    value: "stub",
    label: "Stub (Entwicklung/Test)",
    hint: "Erzeugt Test-Signaturen ohne Cloud-Anbieter. Nicht für den Produktivbetrieb.",
  },
  {
    value: "fiskaly",
    label: "fiskaly SIGN DE (Cloud-TSE)",
    hint: "Online-TSE von fiskaly. API-Zugangsdaten aus dem fiskaly-Dashboard.",
  },
  {
    value: "swissbit_cloud",
    label: "Swissbit Cloud TSE",
    hint: "Cloud-TSE von Swissbit. API-Key und TSS-ID aus dem Swissbit-Portal.",
  },
];

export const TSE_ENVIRONMENT_OPTIONS: { value: TseEnvironment; label: string }[] = [
  { value: "test", label: "Test / Sandbox" },
  { value: "live", label: "Live / Produktion" },
];

export function providerNeedsApiKey(provider: TseProviderKind): boolean {
  return provider !== "stub";
}

export function providerNeedsApiSecret(provider: TseProviderKind): boolean {
  return provider === "fiskaly";
}

export function providerNeedsTssId(provider: TseProviderKind): boolean {
  return provider !== "stub";
}

export function providerNeedsClientId(provider: TseProviderKind): boolean {
  return provider === "fiskaly";
}
